"use client";

import { type HookSafeActionFn, useAction } from "next-safe-action/hooks";
import type { StandardSchemaV1 } from "zod/v4/core/standard-schema";

import { useGenericError } from "~/hooks/useGenericError";

export function useBetterAction<ServerError, S extends StandardSchemaV1 | undefined, CVE, Data>(
	safeActionFn: HookSafeActionFn<ServerError, S, CVE, Data>,
) {
	const onError = useGenericError();

	return useAction(safeActionFn, { onError: (args) => onError(args.error.serverError) });
}
